"use client";

import { useAppContext } from "/context/app-context";
import ClientSideHeader from "/global-layout/headerDetection";
import Footer from "/global-layout/footer";

export default function LayoutShell({
  children,
}: {
  children: React.ReactNode;
}) {
  try {
    const { inAppMode, device } = useAppContext();
    return (
      <>
        {!inAppMode && <ClientSideHeader />}
        {children}
        {!inAppMode && <Footer />}
      </>
    );
  } catch (error) {
    // Fallback when context is not available (e.g., in 404 pages)
    console.warn("LayoutShell: AppContext not available, using fallback layout");
    return (
      <>
        <ClientSideHeader />
        {children}
        <Footer />
      </>
    );
  }
}
